import { object, number, string, boolean } from 'yup';

export const formValuesParamsSchema = object({
  planType: string(),
  idvAmount: number(),
  accidentToDriver: boolean(),
  passengerLiability: boolean(),
  flood: boolean(),
  srcc: boolean(),
});
